import { useContext } from "react";
import AuthenticationContext from "../providers/AuthenticationProvider"

const useAuthentication = () => {

    const authenticationContext = useContext(AuthenticationContext);

    if (!authenticationContext) {

        throw new Error('AuthenticationContext has to be used within <AuthenticationContext.Provider>');

    } else {

        return authenticationContext;

    }
    
}

export default useAuthentication;